import React from 'react';
import { FormattedMessage } from 'react-intl';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash } from '@fortawesome/free-solid-svg-icons';
import CustomSelect from '../../components/customFields/customSelect';
import forms from '../../utils/forms';

const AdminRoutePlanV2RouteSetupPickupSlotVehicle = ({ vehicle, onChange, onRemove }) => {
  const onFieldChange = (fieldName, newValue) => {
    const newVehicle = { ...vehicle };
    newVehicle[fieldName] = newValue;
    onChange(newVehicle);
  };

  const routingProfileOptions = forms.getRoutingProfiles();

  return (
    <div className="form-block m-darker-more m-b-3">
      <div className="row">
        <div className="col-12 col-sm-6">
          <div className="form-group">
            <label className="control-label">
              <FormattedMessage id={'admin.route.plan.setups.setup.field.pickup.slot.vehicle.vehicle.id'} />
            </label>
            <input
              className="form-control"
              placeholder=""
              type="text"
              value={vehicle.vehicleId}
              onChange={(e) => onFieldChange('vehicleId', e.target.value)}
            />
          </div>
        </div>
        <div className="col-12 col-sm-6">
          <div className="form-group">
            <label className="control-label">
              <FormattedMessage id={'admin.route.plan.setups.setup.field.pickup.slot.vehicle.count'} />
            </label>
            <input
              className="form-control"
              placeholder=""
              type="text"
              value={vehicle.count}
              onChange={(e) => onFieldChange('count', e.target.value)}
            />
          </div>
        </div>
        <div className="col-12 col-sm-6">
          <div className="form-group">
            <label className="control-label">
              <FormattedMessage id={'admin.route.plan.setups.setup.field.pickup.slot.vehicle.capacity'} />
            </label>
            <input
              className="form-control"
              placeholder=""
              type="text"
              value={vehicle.capacity}
              onChange={(e) => onFieldChange('capacity', e.target.value)}
            />
          </div>
        </div>
        <div className="col-12 col-sm-6">
          <div className="form-group">
            <label className="control-label">
              <FormattedMessage id={'admin.route.plan.setups.setup.field.pickup.slot.vehicle.max.travel.time'} />
            </label>
            <input
              className="form-control"
              placeholder=""
              type="text"
              value={vehicle.maxTravelTimeInMinutes}
              onChange={(e) => onFieldChange('maxTravelTimeInMinutes', e.target.value)}
            />
          </div>
        </div>
        <div className="col-12 col-sm-6">
          <div className="form-group">
            <label className="control-label">
              <FormattedMessage id={'admin.route.plan.setups.setup.field.pickup.slot.vehicle.max.late.time'} />
            </label>
            <input
              className="form-control"
              placeholder=""
              type="text"
              value={vehicle.maxLateTimeInMinutes}
              onChange={(e) => onFieldChange('maxLateTimeInMinutes', e.target.value)}
            />
          </div>
        </div>
        <div className="col-12 col-sm-6">
          <div className="form-group">
            <label className="control-label">
              <FormattedMessage id={'admin.route.plan.setups.setup.field.pickup.slot.routing.profile'} />
            </label>
            <div className="m-b-2">
              <CustomSelect
                onChange={(routingProfileName) => onFieldChange('routingProfileName', routingProfileName)}
                schema={{
                  title: '',
                  options: routingProfileOptions,
                  showClearOption: true,
                }}
                formData={vehicle.routingProfileName}
              />
            </div>
          </div>
        </div>
      </div>

      <div className="text-right">
        <button className="btn btn-normal-link btn-small" onClick={onRemove}>
          <FontAwesomeIcon icon={faTrash} />{' '}
          <FormattedMessage id={'admin.route.plan.setups.setup.field.pickup.slot.vehicle.remove'} />
        </button>
      </div>
    </div>
  );
};

export default AdminRoutePlanV2RouteSetupPickupSlotVehicle;
